module.exports = __webpack_public_path__ + "img/symbol_10.fcf0131f.png";